export const VIDEO = {
  YOUTUBE: 'https://www.youtube.com',
  VIMEO: 'https://player.vimeo.com',
}

export const SOCIAL = {
  TWITTER: 'https://twitter.com',
  LINKEDIN: 'https://www.linkedin.com',
  FACEBOOK: 'https://www.facebook.com',
}

export const UIPATH = {
  PROD: 'https://www.uipath.com',
}
